//Get currently bundles
const getBundles = (wrapper) => {
  let bundles = JSON.parse(sessionStorage.getItem("bundlesToShow"));
  wrapper.innerHTML = bundles
    .map((bundle) => `<li>${bundle.name.split("-")[1]}</li>`)
    .join("");
  let price = bundles
    .map((bundle) => parseFloat(bundle.price.split("$")[1]))
    .reduce((price, num) => price + num);
  let comparePrice = bundles
    .map((bundle, indx) =>
      parseFloat(
        bundle.comparePrice.split("$")[1] || bundles[indx].price.split("$")[1]
      )
    )
    .reduce((price, num) => price + num);
  document.querySelectorAll(".priceSale").forEach((element) => {
    element.querySelector(".priceBundle").innerHTML = `$${price.toFixed(2)}`;
    element.querySelector(".compare_at_price").innerHTML =
      comparePrice === price ? "" : `$${comparePrice.toFixed(2)}`;
  });
};
//Create elemets image bundle
const getBundleImages = (elements) =>
  elements
    .map((element, indx) =>
      element
        .map(
          (image, indx2) =>
            `<div class="bundle_image_wrapper ${
              indx === 0 && indx2 === 0 ? "active" : ""
            }">${image}</div>`
        )
        .join("")
    )
    .join("");
//Load images from products bundle
const loadImages = () => {
  let productWrapper = document.querySelector(".product-gallery");
  let bundles = JSON.parse(sessionStorage.getItem("bundlesToShow"));
  let images = bundles.map(({ images, bundle }) => {
    let product = { product: bundle, images: images.split("#").slice(0, 2) };
    return product.images.map(
      (image) => `<img src="${image}" class="img-fluid" alt="${bundle}" />`
    );
  });
  productWrapper.classList.add("bundles");

  console.log("images", images, images.flat().join(""));

  productWrapper.innerHTML = `<div class="position-relative">
                                    <div id="principal_bundle_image">
                                        ${images.flat().join(" ")}
                                    </div>
                                    <div class="bundle_images_float slider-nav">
                                        ${getBundleImages(images)}
                                    </div>    
                                </div>`;
};
function showPopup(id) {
  $(".popup_" + id).addClass("overlay_target");
}
function hidePopup(id) {
  var $popup = id ? $(".popup_" + id) : $("#popup_content");

  $popup.addClass("stryx-hide");
  setTimeout(function () {
    $popup.removeClass("overlay_target").removeClass("stryx-hide");
  }, 300);
}

const changeFooter = () => {
  let footer = `
    <div class="bg_foter_footer position_relative" style="border-right-width: 952.5px;"></div>
  
    <footer id="footer" class="contact store-locator kits terms-of-service help-center new stryx-privacy-policy-1 shop shipping-returns">
    <!--HC-Newsletter footer-03 Feb'20-->
    <div class="container">
        <div class="top-footer">
        <div class="width-50">
            <h2 class="text-logo-footer">STAY IN <br> THE LOOP, <br> HANDSOME.</h2>
        </div>
        <div class="width-50">
            <div class="mailing-list">
            <div class="klaviyo-form-PKxCHa klaviyo-form form-version-cid-1"><div class="needsclick undefined kl-private-reset-css-Xuajs1"><form class="needsclick View__FormView-sc-1ou3cq2-0 jSYIJj klaviyo-form-version-cid_1 kl-private-reset-css-Xuajs1" novalidate="" isembed="true" tabindex="-1"><div class="needsclick Column__FormColumn-z5j99u-0 hVFNhP kl-private-reset-css-Xuajs1"><div data-testid="form-row" class="needsclick Row__FormRow-sc-17nghml-0 lnviXl kl-private-reset-css-Xuajs1"><div component="[object Object]" formcomponentstyling="[object Object]" data-testid="form-component" class="needsclick FormComponent__StyledFormComponentWrapper-e0xun6-0 ldYIRX notranslate kl-private-reset-css-Xuajs1" formcomponenttheme="[object Object]"><div class="needsclick TextInput__StyledInputContainer-sc-1o6de9f-1 kvTDNe kl-private-reset-css-Xuajs1"><input type="email" name="email" tabindex="0" styling="[object Object]" placeholder="Enter your email" aria-label="Enter your email" aria-invalid="false" valid="1" options="[object Object]" class="notranslate needsclick TextInput__FormStyledTextInput-sc-1o6de9f-0 gtmJv kl-private-reset-css-Xuajs1"><div class="needsclick ValidationMessage__Container-sc-1agouhi-0 eVRHhz kl-private-reset-css-Xuajs1"></div></div></div><div component="[object Object]" formcomponentstyling="[object Object]" data-testid="form-component" class="needsclick FormComponent__StyledFormComponentWrapper-e0xun6-0 jBjzuA notranslate kl-private-reset-css-Xuajs1" formcomponenttheme="[object Object]"><button type="button" tabindex="0" class="needsclick Button__FormStyledButton-p2mbjt-0 jhJKcM kl-private-reset-css-Xuajs1">Subscribe</button></div></div></div><input type="submit" tabindex="-1" class="notranslate needsclick View__HiddenSubmit-sc-1ou3cq2-1 StXTa kl-private-reset-css-Xuajs1" value="Submit"></form></div></div>
            <div class="success hide">Thank you!</div>
            </div>    
        </div>
        <div style="clear: both;"></div>
        </div>
        
        <div class="bottom-footer">
        <div class="width-50">
            
    <ul class="social-links">
    
        <li>
        <a target="_blank" class="social-facebook" href="https://www.facebook.com/OfficialStryx">

    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60.734px" height="60.733px" viewBox="0 0 60.734 60.733" style="enable-background:new 0 0 60.734 60.733;" xml:space="preserve">
    <g>
        <path d="M57.378,0.001H3.352C1.502,0.001,0,1.5,0,3.353v54.026c0,1.853,1.502,3.354,3.352,3.354h29.086V37.214h-7.914v-9.167h7.914
            v-6.76c0-7.843,4.789-12.116,11.787-12.116c3.355,0,6.232,0.251,7.071,0.36v8.198l-4.854,0.002c-3.805,0-4.539,1.809-4.539,4.462
            v5.851h9.078l-1.187,9.166h-7.892v23.52h15.475c1.852,0,3.355-1.503,3.355-3.351V3.351C60.731,1.5,59.23,0.001,57.378,0.001z"></path>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>
        </a>
        </li>
        <li>
        <a target="_blank" class="social-tweek" href="https://twitter.com/@Stryx_Official">
            <img width="43" height="33" src="//cdn.shopify.com/s/files/1/0008/8621/0596/t/113/assets/tweek-white.png?v=11827257200252577306"> 
        </a>
        </li>
        <li>
        <a target="_blank" class="social-youtube" href="http://youtube.com/Stryx_Official">
            <img width="43" height="33" src="//cdn.shopify.com/s/files/1/0008/8621/0596/t/113/assets/youtube-white.png?v=11206902666906946066"> 
        </a>
        </li>
        <li>
        <a target="_blank" class="social-instagram" href="https://www.instagram.com/stryx_official/">
            <svg height="511pt" viewBox="0 0 511 511.9" width="511pt" xmlns="http://www.w3.org/2000/svg">
                <path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0"></path>
                <path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"></path>
                <path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"></path>
            </svg> 
        </a>
        </li>
        <li> 
        <a target="_blank" class="social-tiktok" href="https://www.tiktok.com/@stryx_official">
            <img width="43" height="33" src="//cdn.shopify.com/s/files/1/0008/8621/0596/t/113/assets/tiktok-white.png?v=2345951161719483565"> 
        </a>
        </li>
    </ul>
                    
    </div>
    <div class="width-50">
        <ul class="links">
        
            <li class="first footer_links_1">
                <a href="/pages/shipping-returns">SHIPPING &amp; RETURNS</a>
            </li>
        
            <li class=" footer_links_2">
                <a href="/pages/contact">CONTACT &amp; HELP</a>
            </li>
        
            <li class=" footer_links_3">
                <a href="/pages/stryx-privacy-policy-1">PRIVACY POLICY</a>
            </li>
        
            <li class="last footer_links_4">
                <a href="/pages/new">TERMS</a>
            </li>
        
        </ul>        
    </div>
        <div style="clear: both;"></div>
    </div>
        <div style="clear: both;"></div>
    </div>
    </footer>
</div>`;
  setTimeout(() => {
    document.querySelector(".wrap_footer").innerHTML = footer;
  }, 200);
};
//Funtion to load page, get bundles and create validations
(() => {
  sessionStorage.setItem("bundleEdit", false);
  let quantity = document.querySelector(".quantity-buttons-container");
  let bundleActive = sessionStorage.getItem("bundleActive");

  if (bundleActive && bundleActive === "true") {
    changeFooter();
    document.querySelector("body").classList.add("get-started");
    document.querySelector(".stamped-product-reviews-badge").remove();
    document
      .querySelector(".color-and-variants-container")
      .classList.add("get-started");
    document
      .querySelector(
        "div.product-info > div > form > div.quantity-buttons-container.grid"
      )
      .remove();
    getBundles(document.querySelector(".products_bundle ul"));
    getBundles(document.querySelector("#productTitle + p + ul"));
    loadImages();
    let logo = header.querySelector(".logo.logo-desktop");
    document.querySelector(".stamped-product-reviews-badge").remove();
    header.innerHTML = "";
    document.querySelector("h1.title").remove();
    titleMobileProduct.remove();
    document.querySelector(".product-info-top-lg .sub-title").style.display =
      "block";
    document.querySelector(".product-info-top-lg .sub-title").style.marginTop =
      "32px";

    document.querySelectorAll(".title").forEach((e) => (e.innerHTML = ""));
    document
      .querySelectorAll("p.sub-title")
      .forEach((e) => (e.innerHTML = "Your Custom Kit"));
    rc_radio_options.style.display = "none";
    let headerBar = `<div class="container" id="header_bundle">
                            <div class="scroll-mobile">
                                <div class="steps-controll">
                                    <a class="step-action" href="/pages/get-started"><p>Questionnaire <span><img srcset="{{ 'Flecha_02.svg' | asset_url }}" /></span></p></a>
                                    <p class="step-action active">Customize Kit <span><img srcset="{{ 'Flecha_02.svg' | asset_url }}" /><span></p>
                                    <p class="step-action disable">Shipping Frequency <span><img srcset="{{ 'Flecha_02.svg' | asset_url }}" /></span></p>
                                    <p class="step-action disable">Review</p>
                                </div>
                            </div>
                        </div>`;

    header.innerHTML = headerBar;
    //Title Modify
    header.querySelector(".container").prepend(logo);
    //EndTitle modify
    next_step.classList.remove("d-none");
    setTimeout(() => {
      quantity.style.display = "none";
      let hidde = document.querySelectorAll(".container_product_details");
      document.querySelector("#stamped-main-widget").remove();
      [...hidde].forEach((e) => e.remove());
      //console.log("VIDEO_SECTION", hidde);
      let x = document.getElementsByName("option-0");
      if (x.length === 1) {
        let button = document.querySelector("#next_step > p");
        tooltip_shade.classList.remove("active");
        button.setAttribute("data-state", true);
        button.classList.remove("disable");
      }
    }, 300);
  } else {
    document.querySelector(".priceSale").remove();
  }
})();
//Change heigth principal
const changeHeight = (step) => {
  let h = document.querySelector(`#started-step-${step}`).clientHeight;
  document.querySelector("#get-started").style.height = `${
    step === 2 ? h : h * 1.05
  }px`;
  document.documentElement.scrollTop = 0;
};
//Change step active in header
[...document.querySelectorAll(".step-action")].forEach(
  (element, indx, elements) => {
    let stepActive = sessionStorage.getItem("stepGetStarted");
    element.addEventListener("click", () => {
      let state = element.getAttribute("class");
      if (state.indexOf("disable") > -1) return;
      //console.log("Cambia step", indx);
      elements.map((e) => e.classList.remove("active"));
      element.classList.add("active");
      sessionStorage.setItem("bundleEdit", true);
      moveContainer(indx);
      changeHeight(indx + 1);
    });
  }
);
//Move steps container
const moveContainer = (step) => {
  sessionStorage.setItem("stepGetStarted", step + 1);
  document.querySelector(".container-steps ").style.left = `-${
    (step - 1) * 100
  }%`;
  let stepsControlls = document.querySelectorAll(".step-action");

  [...stepsControlls].forEach((e, indx) => {
    e.classList.remove("active");
    e.classList.remove("disable");
    if (indx > step) {
      e.classList.add("disable");
    }
  });
  stepsControlls[step].classList.add("active");
};
//Funtion to change to next step
function getNextStep(element) {
  const status = element.getAttribute("data-state");
  if (status === "disable") {
    tooltip_shade.classList.add("active");
    return;
  }
  document.querySelector("#tooltip_shade").classList.remove("active");

  if (sessionStorage.getItem("bundleEdit") === "true") return moveContainer(3);

  let options = document.querySelectorAll(
    "#rc_radio_options .product-subscription__interval-item"
  );
  let optionsWrapper = document.querySelector("#shipping-frequency");
  let optionsSelect = document.querySelector("#rc_radio_options");
  let discount = document
    .querySelector(".rc_label__discount")
    .textContent.trim();
  let contentAux = [];

  [...options].forEach((option, indx) => {
    let frequency = option.textContent.split(" ").filter((x) => x !== "");
    let content = `<div class="frequency-option">   
                        <div data-target="${
                          frequency[frequency.length - 2]
                        } ${frequency[frequency.length - 1]
      .toUpperCase()
      .trim()}">
                            <p class="every-font">Every</p>
                            <p id="frequency">${
                              frequency[frequency.length - 2]
                            }</p>
                            <p id="time-frequency">${frequency[
                              frequency.length - 1
                            ].toUpperCase()}</p>
                            <p id="discount">SAVE ${discount
                              .replace("(", "")
                              .replace(")", "")
                              .replace(":", "")}</p>
                        </div>
                    </div>`;
    contentAux[indx] = content;
  });
  optionsSelect.click();
 

  optionsWrapper.innerHTML = contentAux.join("");

  [...document.querySelectorAll(".frequency-option")].forEach(
    (option, indx, optionsCopy) => {
      option.addEventListener("click", () => {
        optionsCopy.forEach((e) => e.classList.remove("active"));
        option.classList.add("active");
        let titleFrecuency = option
          .querySelector("div")
          .getAttribute("data-target");
        sessionStorage.setItem("unit_type", titleFrecuency.split(" ")[1]);
        sessionStorage.setItem("interval", titleFrecuency.split(" ")[0]);
        frequency_title.innerHTML = `EVERY ${titleFrecuency}`;
        options[indx].click();
        moveContainer(3);
        changeHeight(4);
      });
    }
  );
  moveContainer(2);
  changeHeight(3);
  sessionStorage.setItem("bundleEdit", false);
}

step_3.addEventListener("click", () => {
  document.querySelector(".round > input").click();
  sessionStorage.removeItem("unit_type");
  sessionStorage.removeItem("interval");
  frequency_title.innerHTML = "ONE TIME PURCHASE";
  moveContainer(3);
  changeHeight(4);
});


//Add all products bundle to cart
add_cart_bundle.addEventListener("click", async () => {
  console.log('👉 add_cart_bundle');
  //document.querySelector('.quantity-buttons-container input.btn').click();
  sessionStorage.setItem("bundleActive", "false");
  let bundles = JSON.parse(sessionStorage.getItem("bundlesToShow"));
  let variantOption = Number(sessionStorage.getItem("variantOption")) || 0;
  let shipping_interval_unit_type = sessionStorage.getItem("unit_type");
  let shipping_interval_frequency = Number(sessionStorage.getItem("interval"));
  let properties = shipping_interval_unit_type
    ? {
        shipping_interval_unit_type,
        shipping_interval_frequency,
      }
    : null;

  let queue = bundles.map((bundle) => {
    return {
      id:
        bundle.variants.length <= 1
          ? bundle.variants[0]
          : bundle.variants[variantOption],
      quantity: 1,
      properties,
    };
  });

  //Ajax to add product bundle to cart
  const addToCartAjaxBundle = async () => {
    console.log(queue);
    if (queue.length) {
      console.log("entra");
      let data = queue.shift();
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        success: async function (res) {
          console.log("ok");
          addToCartAjaxBundle();
        },
        error: async function () {
          if (queue.length) {
            console.log("ERROR");
            addToCartAjaxBundle();
          }
        },
      });
    } else {
      console.log("Entra a update");
      setTimeout(() => {
        $.ajax({
          url: "/cart/update.js",
          type: "POST",
          dataType: "json",
          data: { note: "Issues:"+ sessionStorage.getItem("issuesSelected")},
          success: function (result) {
            console.log("RESULT", result);
            window.location.href = "/checkout";
          },
          error: function (jqxhr, status, exception) {
            console.log(exception);
            window.location.href = "/checkout";
          },
        });
      }, 200);
    }
  };
  addToCartAjaxBundle();
});

//Active edit bundle frequency and shade color
function editBundle(step) {
  sessionStorage.setItem("bundleEdit", true);
  moveContainer(step);
}
//Change color shade option bundle
[...document.querySelectorAll(".wrap_swatch input")].forEach((element) => {
  element.addEventListener("change", (e) => {
    // console.log("VALUE COLOR", e, e.target.value);
    let optionsReview = document.querySelectorAll(".shade-att .swatch-element");
    optionsReview.forEach((option, indx) => {
      let value = option.getAttribute("data-value");
      option.querySelector(".color_option_bundle").classList.remove("active");
      option.querySelector(".tooltip").classList.remove("active");
      if (value === e.target.value) {
        option.querySelector(".color_option_bundle").classList.add("active");
        option.querySelector(".tooltip").classList.add("active");
        sessionStorage.setItem("variantOption", indx);
      }
    });
  });
});
//Change color shade option bundle
[...document.querySelectorAll(".shade-att .swatch-element")].forEach(
  (option, indx, options) => {
    let value = option.getAttribute("data-value");
    let optionsWatch = document.querySelectorAll(".wrap_swatch > div");
    option.addEventListener("click", () => {
      options.forEach((op) =>
        op.querySelector(".color_option_bundle").classList.remove("active")
      );
      option.querySelector(".color_option_bundle").classList.add("active");
      optionsWatch.forEach((e) => {
        if (e.getAttribute("data-value") === value) {
          e.querySelector("input + .animation.color").click();
          sessionStorage.setItem("variantOption", indx);
        }
      });
    });
  }
);
//Return home and delete sessionStorage bundleActive
try {
  document
    .querySelector("#header_bundle > .logo")
    .addEventListener("click", () =>
      sessionStorage.setItem("bundleActive", "false")
    );
} catch (e) {}
//Validate to disable button to next step
[...document.getElementsByName("option-0")].forEach((option) => {
  option.addEventListener("change", (e) => {
    let button = document.querySelector("#next_step > p");
    tooltip_shade.classList.remove("active");
    button.setAttribute("data-state", true);
    button.classList.remove("disable");
  });
});
//Change principal bundle image
// [...document.querySelectorAll('.bundle_image_wrapper')].forEach((image, indx, images) => {
//     image.addEventListener('click', () => {
//         images.forEach(e => e.classList.remove('active'));
//         image.classList.add('active');
//         let url = image.querySelector('.img-fluid').getAttribute('src');
//         console.log("URL", url);
//         principal_bundle_image.style.opacity = 0;
//         setTimeout(() => {
//             principal_bundle_image.style.backgroundImage = `url(${url})`;
//         }, 350);
//         setTimeout(() => {
//             principal_bundle_image.style.opacity = 1;
//         }, 500);
//     })
// });

document.getElementsByName("purchase_type").forEach((element) => {
  element.addEventListener("change", () => {
    console.log(element, "👉 change");
    let price = document.querySelector(".rc_block__type--active .rc_price")
      .textContent;
    document.querySelector(".price-change").innerHTML = price;
    let value = element.value;
    console.log("👉👉", element, value, $);
    if (value === "onetime") {
      document
        .querySelector(".grid__items.product_quantity_input")
        .classList.add("show");
    } else {
      document
        .querySelector(".grid__items.product_quantity_input")
        .classList.remove("show");
    }
  });
});

// (function () {
//   $("#rc_container .rc_block__type .rc_label").on("click", function () {
//     var $el = $(this);
//     var $round = $el.parents(".round");
//     var $input = $round.find("input");
//     console.log("👉", $el, $input);
//     $input.not(":checked").prop("checked", true);
//   });
// })();
